// NUEVO_LICENSE: clave de licencia del plugin Nuevo de video.js. Es valida para
// un dominio registrado y todos sus subdominios, asi que unir.net cubre tanto
// prepv como pv. villanueva.edu es otro dominio y necesita su propia clave.
// En localhost el plugin funciona sin clave, no hace falta rellenarla.
// La clave viaja en el bundle y es visible en el navegador: no es un secreto.
const NUEVO_LICENSE_UNIR = '110958414a095447'
const NUEVO_LICENSE_VILLANUEVA = '120e5d5f0509445612061f560012'

const environments = {
  // localhost
  'http://localhost:8080': {
  // 'VIDEO_EVENTS_URL': 'http://localhost:8081'
    'VIDEO_EVENTS_URL': 'https://prepvstats.lti.unir.net',
    'NUEVO_LICENSE': ''
  },
  // TEST
  'https://prepv.lti.unir.net': {
    'VIDEO_EVENTS_URL': 'https://prepvstats.lti.unir.net',
    'NUEVO_LICENSE': NUEVO_LICENSE_UNIR
  },
  // PROD
  'https://pv.lti.unir.net': {
    'VIDEO_EVENTS_URL': 'https://pvstats.lti.unir.net',
    'NUEVO_LICENSE': NUEVO_LICENSE_UNIR
  },
  // ---- VILLANUEVA ----
  // TEST
  'https://prepv.lti.villanueva.edu': {
    'VIDEO_EVENTS_URL': 'https://prepvstats.lti.villanueva.edu',
    'NUEVO_LICENSE': NUEVO_LICENSE_VILLANUEVA
  },
  // PROD
  'https://pv.lti.villanueva.edu': {
    'VIDEO_EVENTS_URL': 'https://pvstats.lti.villanueva.edu',
    'NUEVO_LICENSE': NUEVO_LICENSE_VILLANUEVA
  }
}

export default environments[window.location.origin]



// WEBPACK FOOTER //
// ./src/setttings.js